import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconClose = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M11.475 10.0607C10.8892 9.47495 10.8892 8.5252 11.4749 7.93942L17.0001 2.41429C17.3906 2.02377 17.3906 1.3906 17.0001 1.00008C16.6096 0.609551 15.9764 0.609551 15.5859 1.00007L10.0607 6.5252C9.47495 7.11099 8.5252 7.11099 7.93942 6.5252L2.41429 1.00008C2.02376 0.609551 1.3906 0.609551 1.00008 1.00008C0.609551 1.3906 0.60955 2.02376 1.00007 2.41429L6.5252 7.93942C7.11099 8.5252 7.11099 9.47495 6.5252 10.0607L1.00008 15.5859C0.609551 15.9764 0.609551 16.6096 1.00008 17.0001C1.3906 17.3906 2.02376 17.3906 2.41429 17.0001L7.93942 11.475C8.5252 10.8892 9.47495 10.8892 10.0607 11.4749L15.5859 17.0001C15.9764 17.3906 16.6096 17.3906 17.0001 17.0001C17.3906 16.6096 17.3906 15.9764 17.0001 15.5859L11.475 10.0607Z",
		fill: "white"
	})
});
export default SvgIconClose;
